import React from 'react';
import ReactDOM from 'react-dom';
import * as dotenv from 'dotenv';
import 'index.css';
import 'i18n';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import frLocale from 'date-fns/locale/fr';

import { client } from 'apolloInitializer';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider, ToolsProvider, MainProvider } from 'Contexts';

import App from 'App';

dotenv.config();

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={frLocale}
      >
        <MainProvider>
          <AuthProvider>
            <ToolsProvider>
              <App />
            </ToolsProvider>
          </AuthProvider>
        </MainProvider>
      </LocalizationProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
